import { useLayoutEffect, useMemo } from 'react';

/**
 * Returns a dedicated canvas worker and takes care of destroying the worker and the canvases (if any) once the component is unmounted.
 */
function useDedicatedCanvasWorker(dynamicZoomLevelStartDate, isDynamic) {
  const worker = useMemo(() => {
    if (!isDynamic || (isDynamic && dynamicZoomLevelStartDate)) {
      return new Worker(
        new URL('../webWorkers/canvasWorker.ts', import.meta.url),
        {
          type: 'module',
        },
      );
    }

    return null;
  }, [isDynamic, dynamicZoomLevelStartDate]);

  useLayoutEffect(() => {
    return () => {
      if (worker) {
        worker.postMessage({
          type: 'Destroy',
        });
        worker.terminate();
      }
    };
  }, [isDynamic, dynamicZoomLevelStartDate]);

  return worker;
}

export default useDedicatedCanvasWorker;
